import { useQuery } from '@apollo/client';
import { useLoadEntitlementList } from '@css-xp/ppc-custom-hooks';
import { FetchEntitlementsForCartQueryType, FetchEntitlementsForCartQueryVariables } from '@css-xp/ppc-cart-common';
import { fetchEntitlementsForCart } from '../../../../queries/fetch-entitlements';
import { fetchEntitlementsTotalCountForCartQuery } from '../../../../queries/fetch-entitleemnts-count';

export interface Config {
  isChunkEnabled?: boolean;
  skip?: boolean;
}

export const useLoadEntitlements = (variables: FetchEntitlementsForCartQueryVariables, config: Config) => {
  const {
    isLoading: isFetchEntitlementsLoading,
    error: fetchEntitlementsError,
    data: fetchEntitlementsResponse,
    refetch: refetchEntitlementsResponse,
  } = useLoadEntitlementList(fetchEntitlementsForCart, variables, {
    autoFetch: true,
    singleBatchCount: 30,
    skip: !config.isChunkEnabled || config.skip,
    dataPath: 'transactionAccount.productSubscriptions',
    totalCountQuery: fetchEntitlementsTotalCountForCartQuery,
  });

  const {
    loading: isFetchEntitlementsLoadingOld,
    error: fetchEntitlementsErrorOld,
    data: fetchEntitlementsResponseOld,
    refetch: refetchEntitlementsResponseOld,
  } = useQuery<FetchEntitlementsForCartQueryType, FetchEntitlementsForCartQueryVariables>(fetchEntitlementsForCart, {
    variables: variables,
    skip: config.isChunkEnabled || config.skip,
  });

  if (config.isChunkEnabled) {
    return {
      loading: isFetchEntitlementsLoading,
      error: fetchEntitlementsError,
      data: fetchEntitlementsResponse,
      refetch: refetchEntitlementsResponse,
    };
  }
  return {
    loading: isFetchEntitlementsLoadingOld,
    error: fetchEntitlementsErrorOld,
    data: fetchEntitlementsResponseOld,
    refetch: refetchEntitlementsResponseOld,
  };
};
